export function pathMatches(currentPath: string, matchPath: string, exact: boolean = false) {
  if (exact) return matchPath === currentPath;
  return currentPath.startsWith(matchPath);
}
